export class Operators {
  static And = 'AND';
  static Or = 'OR';
}
